const Logo = ({ size = 44, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className} aria-label="Logo Maricleia Araújo" role="img">
        <circle cx="50" cy="50" r="47" stroke="url(#ring)" strokeWidth="2.5" />
        <circle cx="50" cy="50" r="40" fill="#FAF7FC" stroke="#E8DFF5" strokeWidth="1" />
        <path
            d="M50 74 C 34 63, 26 54, 26 44 C 26 36, 32 31, 39 31 C 44 31, 48 34, 50 38 C 52 34, 56 31, 61 31 C 68 31, 74 36, 74 44 C 74 54, 66 63, 50 74 Z"
            fill="url(#heart)"
        />
        <path d="M50 66 C 50 54, 56 46, 66 42 C 66 54, 60 62, 50 66 Z" fill="#FAF7FC" opacity="0.9" />
        <path d="M50 66 C 52 57, 57 50, 64 45" stroke="#5D4A7A" strokeWidth="1.6" strokeLinecap="round" />
        <defs>
            <linearGradient id="ring" x1="0" y1="0" x2="100" y2="100">
                <stop stopColor="#C5B4D6" />
                <stop offset="1" stopColor="#8BA3C7" />
            </linearGradient>
            <linearGradient id="heart" x1="26" y1="31" x2="74" y2="74">
                <stop stopColor="#C5B4D6" />
                <stop offset="1" stopColor="#8BA3C7" />
            </linearGradient>
        </defs>
    </svg>
);

export default Logo;
